import React from "react";

const CircularGauge = ({ grade, size = 40 }) => {
  const normalized_grade = Math.min(10, Math.max(0, grade ?? 0));
  const percentage = normalized_grade / 10;
  const radius = (size - 6) / 2;
  const circumference = 2 * Math.PI * radius;
  const stroke_dash_offset = circumference * (1 - percentage);
  const grade_color =
    normalized_grade >= 7 ? "#05CD99" : normalized_grade >= 5 ? "#FBBC05" : "#EF4040";
  const font_size = Math.max(10, Math.round(size * 0.32));

  return (
    <div
      className="relative shrink-0"
      style={{ width: size, height: size }}
    >
      <svg
        width={size}
        height={size}
        className="-rotate-90"
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#f0f0f0"
          strokeWidth="3"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={grade_color}
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={stroke_dash_offset}
          className="transition-all duration-700 ease-out"
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span
          className="font-bold text-gray-700 tabular-nums"
          style={{ fontSize: font_size }}
        >
          {normalized_grade}
        </span>
      </div>
    </div>
  );
};

export default CircularGauge;
